const space = [0, 4, 8, 12, 16, 24, 32, 48, 56, 64, 96, 128, 10, 20, 40, 105]
// experimental sizing: 12 (10px), 13 (20px), 14 (40px), 15 (105px)
const breakpoints = ['798px']

const colors = {
  primary: [
    '#FFF7AE',
    '#FFED00',
    '#FFD400'
  ],
  secondary: [
    '#0CA1EB',
    '#1A56F1',
    '#0236BC'
  ],
  tertiary: [
    '#E5F8F5',
    '#23CAA7',
    '#0FB799'
  ],
  neutrals: [
    '#FFFFFF',
    '#F7F7F7',
    '#D6D6D6',
    '#51585B',
    '#252829',
    '#F0F9FE',
    '#000000'
  ],
  error: [
    '#FFE8EE',
    '#FF3A72',
    '#E2175A'
  ],
  material: [
    '#E8EAFA',
    '#333333CC'
  ]
}

export { space, breakpoints, colors }
